module.exports = __webpack_public_path__ + "img/vectorply-logo.cbeccaa6.jpg";